import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Categoria } from 'my-lib-sanfelici';
import { CategorieService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-categorie-create',
  templateUrl: './categorie-create.component.html',
  styleUrls: ['./categorie-create.component.css']
})
export class CategorieCreateComponent implements OnInit {

    categoria: any;
    categorie: Observable<Categoria[]>;


   id: string;
    constructor(
      private categorieService: CategorieService,
      private router: Router
    ) { }

    submit() {
        this.categorieService.crea( this.categoria);
        this.router.navigate(['categorie']);
    }

    ngOnInit() {
     this.categoria = {
       catalogo_id: null,
      UrlImg: null,
      slug: null ,
       Attivo: true,
       parent: null,
      image_id: null};

  }

}
